(function() {
    'use strict';

    angular
        .module('2017SiteDesign')
        .controller('MainController', MainController)
        .controller('HeadController', HeadController)
        .directive("angularLoaded", function() {
            return function(scope, element) {
                element.addClass('angular-loaded');
                element.removeClass('angular-not-loaded');
            }
        });

    /** @ngInject */

    function MainController($cookies, $location, moment) {
        if (!$cookies.get('Referral')) {
            $cookies.put('Referral', $location.absUrl(), { path: '/', expires: moment().add(30, 'days').toDate(), domain: '.hud.ac.uk' });
        }
        if (!$cookies.get('referralNow')) {
            $cookies.put('referralNow', $location.absUrl(), { path: '/', domain: '.hud.ac.uk' });
        }
    }

    function HeadController($scope, sharedProperties, $location, $rootScope) {
        var vm = this;
        vm.inverted = sharedProperties.getInverted();
        $scope.$on('inverted', function(event, data) {
            vm.inverted = data;
        });
        if ($location.search().modal) {
            $rootScope.modals[$location.search().modal] = true;
            $rootScope.modalOpen = true;
        }
    }
})();